import script from "./BaseTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTable.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTable.vue?vue&type=style&index=0&id=17b09c06&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b09c06"]])

export default __exports__